import { Product } from "@/src/types/tenant";

export function matchesPriceRange(price: number, rangeId: string): boolean {
  if (rangeId === "under-300")  return price < 300;
  if (rangeId === "300-600")    return price >= 300 && price < 600;
  if (rangeId === "600-1000")   return price >= 600 && price < 1000;
  if (rangeId === "above-1000") return price >= 1000;
  return false;
}

export function matchesCurator(p: Product, tagValue: string): boolean {
  return (p.tags ?? []).some((t) => t.toLowerCase() === tagValue.toLowerCase());
}
